import axios from 'axios'
import authHeader from './auth-header'
import Config from '../../config'
import Vue from "vue";

if (localStorage.getItem('gpsServers')) {
    Vue.prototype.$gpsServers = JSON.parse(localStorage.getItem('gpsServers'))
} else {
    Vue.prototype.$gpsServers = Config.gpsServers
}
if (localStorage.getItem('apiServers')) {
    Vue.prototype.$apiServers = JSON.parse(localStorage.getItem('apiServers'))
} else {
    Vue.prototype.$apiServers = Config.apiServers
}
const serverAddress = `${Vue.prototype.$apiServers.url}/admin`


class ModelService {
  // eslint-disable-next-line class-methods-use-this
  getList() {
    return axios.post(`${Vue.prototype.$apiServers.url}/admin/model/list`, { }, { headers: authHeader() })
      .then(response => response.data)
  }

  // eslint-disable-next-line class-methods-use-this
  getById(data) {
    const promise = axios.post(`${Vue.prototype.$apiServers.url}/admin/model/byId`, { id: data.id }, { headers: authHeader() })
    return promise.then(response => response.data)
  }

  // eslint-disable-next-line class-methods-use-this
  add(data) {
    const promise = axios.post(`${Vue.prototype.$apiServers.url}/admin/model/add`,
      data, { headers: authHeader() })

    return promise.then(response => response.data)
  }

  // eslint-disable-next-line class-methods-use-this
  update(data) {
    const promise = axios.post(`${Vue.prototype.$apiServers.url}/admin/model/update`,
      {
        // eslint-disable-next-line no-underscore-dangle
        id: data._id,
        title: data.title,
        protocol: data.protocol,
        port: data.port,
      }, { headers: authHeader() })

    return promise.then(response => response.data)
  }

  // eslint-disable-next-line class-methods-use-this
  delete(data) {
    const promise = axios.post(`${Vue.prototype.$apiServers.url}/admin/model/delete`,
      {
        data: {
          // eslint-disable-next-line no-underscore-dangle
          id: data._id,
        },
        headers: authHeader(),
      })
    return promise.then(response => response.data)
  }
}

export default new ModelService()
